<template>
	<div class="container">
		<div class="main_box">
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="200"
				data-aos-offset="0"
				data-aos-once="true"
				class="title"
			>关于宝瑞源</div>
			<div
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="300"
				data-aos-offset="0"
				data-aos-once="true"
				class="block_1"
			>
				<div class="txt">
					宝瑞源生物技术（北京）有限公司为中关村高新技术企业、北京市高新技术企业、“专精特新”企业，公司地址位于房山窦店宝瑞源工业园，专业从事体外诊断试剂的研发、生产、销售和技术服务。房山窦店的生产基地，占地60亩，建筑面积3万余平方米，公司具有独立的研发中心和质检中心，厂区建设有十万级和万级(局部百级)标准的净化车间，具有全套分子诊断试剂生产线及相应配套设施。
				</div>
				<div class="txt">
					宝瑞源生物团队现已拥有磁珠法技术平台、一管法微量核酸释放剂平台、自动化核酸提取平台，开发了包括乙肝、丙肝、艾滋病、手足口病、呼吸道疾病等荧光PCR产品。
				</div>
				<div class="btn" @click="goContact">
					联系我们&ensp;<van-icon name="down" size="12px" color="#C8000A" style="top: 2px;transform: rotate(-90deg);" />
				</div>
				<img src="../../../assets/img_public/about/block1.webp" />
				<div class="txt">
					宝瑞源生物技术(北京)有限公司为美国CorDx Union集团旗下子公司。CorDx Union（简称CU）成立于2006年，是综合研发、生产、营销、服务为一体的国际化集团公司，设有Accu News准信、Coretests库尔科技、Abiores佳宝瑞源、Jtests建英佳、Bonore保诺塑业、Cupet夕友新能源等品牌系，共21家子公司。
				</div>
				<div class="txt">
					CU以医疗器械&诊断试剂为主业，产品销往170多个国家和地区，在全球拥有上亿用户，广泛应用于临床检验、基层医疗、现场执法、疫情监控、灾难救援、家庭自测及健康管理等领域。
				</div>
				<div class="txt">
					CU全球拥有四个研究院，布局于加州SD，北京大兴，河北雄安，中国海南岛，持续提升分子诊断、胶体金层析、荧光免疫、生物芯片、重组蛋白、mRNA疫苗、宠物用品、电池材料、Ai质量管理系统等科技创新平台。诊疗产品主要用于传染病、肿瘤、心脑血管、炎症、药物滥用等病症。CU制造基地总面积30万平米，同时也为医药同行提供优质服务。
				</div>
				<div class="txt">
					CU以“安全有效 使命必达”为宗旨，秉承“从有机到安息 全供应链服务”的愿景，充分运用现代生物工程技术和医学研究成果，打造超一流医药企业，热心公益，为全球健康事业服务！
				</div>
				<div class="txt">
					公司视人才为企业之本，利润之源，积极引进国内外高技术人才，重视员工的在职培训和个人价值的提升，欢迎各界有识之士的加盟!
				</div>
				<img src="../../../assets/img_public/about/block2.webp" />
				<div class="txt">
					CU以“安全有效 使命必达”为宗旨，秉承“从有机到安息 全供应链服务”的愿景，充分运用现代生物工程技术和医学研究成果，打造超一流医药企业，热心公益，为全球健康事业服务！
				</div>
				<div class="txt">
					公司视人才为企业之本，利润之源，积极引进国内外高技术人才，重视员工的在职培训和个人价值的提升，欢迎各界有识之士的加盟!
				</div>
				<div class="btn" @click="goCorDx">
					关于CorDx&ensp;<van-icon name="down" size="12px" color="#C8000A" style="top: 2px;transform: rotate(-90deg);" />
				</div>
			</div>
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			isLoading: true,  //界面loading
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//跳转联系我们
		goContact() {
			let that = this;
			that.$router.push({ path: '/contact.html' });
		},
		//跳转官网
		goCorDx() {
			window.location.href = 'https://cordx.com/about';
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	.block_1{
		padding: 0 16px 40px 16px;
		img{
			width: 100%;
			margin: 30px 0;
		}
		.btn{
			display: inline-block;
			margin-top: 10px;
			color: #C8000A;
			font-size: 12px;
		}
		.txt{
			line-height: 2;
			text-indent: 28px;
		}
	}
	.title{
		padding: 0px 0 30px 0;
		font-size: 24px;
		font-weight: bold;
		text-align: center;
	}
}
</style>